import { AUTHENTICATION_ROUTES, isAuthRoute } from "./authentication";
import { CLIENT_ROUTES } from "./client";
import { DASHBOARD_ROUTES } from "./dashboard";
import { EMPLOYEE_ROUTES } from "./employee";
import { EXPENSE_ROUTES } from "./expense";
import { GENERAL_ROUTES } from "./general";
import { TARIFF_ROUTES } from "./payment";
import { PROFILE_ROUTES } from "./profile";
import { REPAIR_ROUTES } from "./repair";
import { REPORTS_ROUTES } from "./reports";
import { SALARY_ROUTES } from "./salary";
import { SETTINGS_ROUTES } from "./settings";
import { SHIFT_ROUTES } from "./shift";
import { STORE_ROUTES } from "./store";
import { TRACK_ROUTES } from "./track";

export const ROUTES = [
    ...AUTHENTICATION_ROUTES,
    ...CLIENT_ROUTES,
    ...EMPLOYEE_ROUTES,
    ...SALARY_ROUTES,
    ...EXPENSE_ROUTES,
    ...TARIFF_ROUTES,
    ...PROFILE_ROUTES,
    ...REPAIR_ROUTES,
    ...REPORTS_ROUTES,
    ...SETTINGS_ROUTES,
    ...GENERAL_ROUTES,
    ...SHIFT_ROUTES,
    ...STORE_ROUTES,
    ...DASHBOARD_ROUTES,
    ...TRACK_ROUTES,
];

// Helpers for routing
export { isAuthRoute };
